export default "__VITE_ASSET__Dlxn6vTq__"